// Globals
import { useTranslation } from 'react-i18next';

// Components
import { StyledButtonsWrapper, StyledTitleModal, StyledSubtitleModal } from './HasUnsavedChangesModalStyles';
import { Modal, ModalSize } from '@/components';
import { Button } from '@/ui';

interface IHasUnsavedChangesModalProps {
  isOpened: boolean;
  handleCloseModal: () => void;
  handleSaveAndClose: () => void;
  handleExitAndClose: () => void;
}

const HasUnsavedChangesModal = ({
  isOpened,
  handleCloseModal,
  handleSaveAndClose,
  handleExitAndClose,
}: IHasUnsavedChangesModalProps) => {
  const { t } = useTranslation(['common']);

  return (
    <Modal visible={isOpened} onCancel={handleCloseModal} size={ModalSize.LARGE}>
      <StyledTitleModal>{t('save_changes_modal_title')}</StyledTitleModal>
      <StyledSubtitleModal>{t('save_changes_modal_subtitle')}</StyledSubtitleModal>
      <StyledButtonsWrapper>
        <Button onClick={handleExitAndClose}>{t('save_changes_modal_exit_button')}</Button>
        <Button onClick={handleSaveAndClose} type="primary">
          {t('save_changes_modal_save_button')}
        </Button>
      </StyledButtonsWrapper>
    </Modal>
  );
};

export default HasUnsavedChangesModal;
